<div class="-popup" *ngIf="showCookiePopup">
  <div translate class="-text">cookie-text</div>
  <div class="d-flex justify-content-between align-items-center mt-1">
    <a href="/privacy-policy" target="_blank" translate class="upp-link">
      {{ 'Leggi la Privacy Policy' | translate }}
    </a>
    <button mat-flat-button color="primary" (click)="closeCookie()">{{'Accetta' | translate }}</button>
  </div>
</div>
